module.exports = __webpack_public_path__ + "img/aws-logo.12276950.png";